import { PollH, SignOutAlt } from '@mehilainen/mds-customer/icons'
import { Badge } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'

import useUserState from '../../../domain/reserve/hooks/useUserState'
import { useModalEvents } from '../../../xstate/events'
import useLoginState from '../../hooks/useLoginState'
import { useOHC } from '../../hooks/useOHC'
import { useEhoitoNavigationEvents } from '../../services/omApi'
import NoEvents from '../OMLight/NoEvents'

import { UserMenu } from './UserMenu'

const UserButton: React.FC = () => {
  const { i18n } = useTranslation()
  const { isOHCSide, ohcAllowedStatus } = useOHC()
  const { t } = useTranslation()
  const { openOMLightModal } = useModalEvents()
  const { events } = useEhoitoNavigationEvents()
  const { loginStatus, logout } = useLoginState()
  const {
    userState: { user, pending: userPending },
  } = useUserState()
  const isOHC = isOHCSide && ohcAllowedStatus === 'allowed'
  const hasEvents = isOHC && events && events.length > 0

  if (loginStatus !== 'authenticated' || userPending) {
    return null
  }

  return (
    <Badge badgeContent={hasEvents ? events.length : undefined} color="error">
      <UserMenu
        name={user?.firstName}
        topComponent={hasEvents ? undefined : isOHC ? <NoEvents /> : undefined}
        events={
          events
            ? events.map((event) => ({
                onClick: () => {
                  openOMLightModal(event.carePlanGuid)
                },
                eventContentProps: {
                  title: event.i18n?.name[i18n.language],
                  startIcon: <PollH />,
                  description: event.i18n?.description[i18n.language],
                },
              }))
            : undefined
        }
        links={[
          {
            children: t('component.userButton.list.healthInformation'),
            component: 'a',
            href: `${process.env.REACT_APP_OMAMEHILAINEN_URL}/om-app/`,
            className: 'no-external-icon no-link-styles',
          },
        ]}
        ButtonProps={{
          children: t('component.userButton.logout'),
          variant: 'outlined',
          size: 'large',
          startIcon: <SignOutAlt />,
          onClick: () => {
            logout()
          },
        }}
        ariaLabel={t('component.userButton.label', { name: user?.firstName })}
      />
    </Badge>
  )
}

export default UserButton
